import Vue from 'vue'

/**
 * @author Jose Luis R
 * Finish LV process and pass to VR
 * @param id Casualty's id
 * @return {Object}
 */

const finishLV = ({ id }) =>
  Vue.$http.put(`sinisters/affected/change_VR/${id}/`)
    .then((response) => response.data)
    .catch((err) => { throw err })

export default finishLV



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/finishLV.js